export const formMessageActionTypes = {
    DISPLAY_WARNING_MESSAGE: "DISPLAY_WARNING_MESSAGE",
    DISPLAY_ERROR_MESSAGE: "DISPLAY_ERROR_MESSAGE",
    DISPLAY_DUPLICATE_MESSAGE: "DISPLAY_DUPLICATE_MESSAGE",
    DISPLAY_SUCCESS_MESSAGE: "DISPLAY_SUCCESS_MESSAGE",
    CLEAR_ERROR_MESSAGE: "CLEAR_ERROR_MESSAGE",
}

const showWarningMessage = (message, warning, header) => ({
    type: formMessageActionTypes.DISPLAY_WARNING_MESSAGE,
    payload: { message, warning, header }
});

const showErrorMessage = (message, error) => ({
    type: formMessageActionTypes.DISPLAY_ERROR_MESSAGE,
    payload: { message, error }
});

const showDuplicateMessage = (message, duplicate) => ({
    type: formMessageActionTypes.DISPLAY_DUPLICATE_MESSAGE,
    payload: { message, duplicate }
});

const showSuccessMessage = (message, success) => ({
    type: formMessageActionTypes.DISPLAY_SUCCESS_MESSAGE,
    payload: { message, success }
})

const clearMessage = () => ({
    type: formMessageActionTypes.CLEAR_ERROR_MESSAGE,
});

export function displayWarningMessage(message, warning, header) {
    return (dispatch) => {
        dispatch(showWarningMessage(message, warning, header));
    }
}

export function displayErrorMessage(message, error) {
    return (dispatch) => {
        dispatch(showErrorMessage(message, error));
    }
}

export function displayDuplicateMessage(message, duplicate) {
    return (dispatch) => {
        dispatch(showDuplicateMessage(message, duplicate));
    }
}

export function displaySuccessMessage(message, success) {
    return (dispatch) => {
        dispatch(showSuccessMessage(message, success));
    }
}

export function clearErrorMessage() {
    return (dispatch) => {
        dispatch(clearMessage());
    }
}
